import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShieldCheck2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="shield-check-2, protect, security, check"><path d="M9.5 12.25L11 13.75L14.5 10.25M3.75 3.75H20.25V17.75L12 22.25L3.75 17.75V3.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconShieldCheck2;
